import axios from "axios";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import ImageUploaderVanila from "../components/ImageUploaderVanila";
import Submit from "../components/Submit";
import { updateLoading } from "../store/reducers/loading";
import { color, fullPage, levelBtn, overflowY } from "../styles/theme";

const HunterDashboard = () => {
	const [item, setItem] = useState(0);
	const [data, setData] = useState({
		title: "",
		severity: "",
		environment: "",
		sourceCode: "",
		description: "",
		reproduce: "",
		expectedResult: "",
		actualResult: "",
		attechedFile: "",
	});
	const list = [
		{
			process: "open",
			title: "DreamPlus",
			createAt: "2022.11.24 5.47:46",
			level: "Critical",
			color: "#9C203E",
		},
		{
			process: "open",
			title: "ApeCoin",
			createAt: "2022.09.12 3.20:18",
			level: "Low",
			color: "#2C194B",
		},
		{
			process: "open",
			title: "MakerDAO",
			createAt: "2022.02.24 7.19:43",
			level: "High",
			color: "#686A0E",
		},
	];

	const movieTest = () => {
		setData({
			title: "DreamPlus",
			severity: "Low",
			environment: `MacOS Monteray v12.1.1\nNode v14\nSolidity ^0.5.0
			`,
			sourceCode: `function withdrawAll() external {\n
				uint256 balance = getUserBalance(msg.sender);\n
        require(balance > 0, "Insufficient balance");\n\n

        (bool success, ) = msg.sender.call{value: balance};\n
        require(success, "Failed to send Ether");\n
				\n
        userBalances[msg.sender] = 0;\n
    	}
			`,
			description: `The Reentrancy attack is one of the most destructive attacks in the Solidity smart contract. A reentrancy attack occurs when a function makes an external call to another untrusted contract. Then the untrusted contract makes a recursive call back to the original function in an attempt to drain funds.

When the contract fails to update its state before sending funds, the attacker can continuously call the withdraw function to drain the contract’s funds. A famous real-world Reentrancy attack is the DAO attack which caused a loss of 60 million US dollars.`,
			reproduce: `1. Login as Admin \n2. Go to a course page \n3. Turn editing on \n4. Add a "Label" resource \n5. On the following page, enter some arbitrary label text \n6. Press the Save button`,
			expectedResult:
				"On the following page, a newly created label is displayed on the course page",
			actualResult: "On the following page, the label is not displayed on the course page",
			attechedFile: "",
		});
	};

	const dispatch = useDispatch();

	const onChangeHandler = (e: any, key: string) => {
		const obj: any = {};
		obj[key] = e.target.value;
		setData({ ...data, ...obj });
	};

	const onSubmitHandler = async () => {
		dispatch(updateLoading(true));
		const uploadObj = { ...data };

		await axios.post("http://localhost:4000/api/bugreport", uploadObj, {
			headers: {
				"Content-Type": "application/json",
			},
		});
		dispatch(updateLoading(false));
	};

	return (
		<HunterSection>
			<NavList>
				<div className="status">
					<span className="total">Total List : 3</span>
					<div className="labelBox">
						<div className="labelRow">
							<div className="level" style={{ background: color.yellow }}>
								Open
							</div>
							<span>: 3</span>
						</div>

						<div className="labelRow">
							<div className="level" style={{ background: color.blue }}>
								Close
							</div>
							<span>: 0</span>
						</div>

						<div className="labelRow" style={{ marginBottom: "0" }}>
							<div className="level" style={{ background: color.purple }}>
								Rewarded
							</div>
							<span>: $1000</span>
						</div>
					</div>
				</div>
				{list.map((el, idx) => {
					return (
						<li
							onClick={() => setItem(idx)}
							key={el.title}
							style={{
								background: idx === item ? "#303030" : "none",
							}}
						>
							<div className="header">
								<span>{el.process}</span>
								<span>{el.createAt}</span>
							</div>
							<h3>{el.title}</h3>
							<div className="level" style={{ background: el.color }}>
								{el.level}
							</div>
						</li>
					);
				})}
			</NavList>

			<MainItem>
				<TopDesc>
					<ProjectName>
						<img src="/dummy/dreamplus.png" alt="project" onClick={() => movieTest()} />
						<div className="content">
							<input
								placeholder="Title"
								value={data.title}
								onChange={(e) => onChangeHandler(e, "title")}
							/>
							{/* <div className="subContent">
								<input placeholder="Title" />
								<input placeholder="Bug ID" />
							</div> */}

							<div className="severity">
								<span>severity</span>

								<select
									className="levelRow"
									name="level"
									// defaultValue="Low"
									value={data.severity}
									onChange={(e) => onChangeHandler(e, "severity")}
								>
									<option value="Critical">Critical</option>
									<option value="High">High</option>
									<option value="Medium">Medium</option>
									<option value="Low">Low</option>
								</select>
							</div>
						</div>
					</ProjectName>

					{/* <Description>
						<div className="descItem">
							<span className="descTitle">LAST updated</span>
							<div className="descContent">2022. 11. 24 5:47:46</div>
						</div>
						<div className="descItem">
							<span className="descTitle">Reward</span>
							<span className="descContent">100 - 200</span>
						</div>
						<div className="descItem">
							<span className="descTitle">created</span>
							<span className="descContent">2022. 11. 24 5:47:</span>
						</div>
						<div className="descItem">
							<span className="descTitle">status</span>
							<span className="level" style={{ background: color.red }}>
								review
							</span>
						</div>
					</Description> */}
				</TopDesc>

				<DescriptBox>
					<h2>Environment</h2>
					<textarea
						placeholder="MacOS Monteray v12.1.1&#10;Node v14&#10;Solidity ^0.5.0"
						value={data.environment}
						onChange={(e) => onChangeHandler(e, "environment")}
					></textarea>
				</DescriptBox>

				<DescriptBox>
					<h2>Source code</h2>
					<textarea
						placeholder="const sample = () => { ... }"
						value={data.sourceCode}
						onChange={(e) => onChangeHandler(e, "sourceCode")}
					></textarea>
				</DescriptBox>

				<DescriptBox>
					<h2>Description</h2>
					<textarea
						value={data.description}
						placeholder="Description"
						onChange={(e) => onChangeHandler(e, "description")}
					></textarea>
				</DescriptBox>

				<DescriptBox>
					<h2>Steps to reproduce</h2>
					{/* <div
						placeholder="&#10;&#10;"
					/> */}
					<textarea
						placeholder="1. Login as Admin 2. ..."
						value={data.reproduce}
						onChange={(e) => onChangeHandler(e, "reproduce")}
					></textarea>
				</DescriptBox>

				<DescriptBox>
					<h2>Expected result</h2>
					<textarea
						placeholder="a newly created label is displayed on the course page"
						value={data.expectedResult}
						onChange={(e) => onChangeHandler(e, "expectedResult")}
					></textarea>
				</DescriptBox>

				<DescriptBox>
					<h2>Actual result</h2>
					<textarea
						value={data.actualResult}
						placeholder="On the following page"
						onChange={(e) => onChangeHandler(e, "actualResult")}
					></textarea>
				</DescriptBox>

				<DescriptBox>
					<h2>Atteched file</h2>
					{/* <textarea></textarea> */}
					<ImageUploaderVanila />
				</DescriptBox>

				<div style={{ margin: "0 auto", marginBottom: "3rem" }}>
					<Submit text="Submit" onClick={() => onSubmitHandler()} />
				</div>
			</MainItem>
		</HunterSection>
	);
};

const HunterSection = styled.div`
	${fullPage}
`;

const TopDesc = styled.div`
	display: flex;
	flex-direction: column;
	padding: 2rem;
	box-sizing: border-box;
	background: #262626;
	margin-bottom: 4rem;
	border-radius: 0.4rem;
`;

const NavList = styled.ul`
	${overflowY}

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	flex: 1.6;
	height: 100%;
	padding: 0;
	padding-top: 6rem;
	box-sizing: border-box;
	border-right: 0.5px solid #3a3939;
	white-space: pre-wrap;

	.status {
		display: flex;
		flex-direction: column;
		width: 90%;
		padding-left: 1rem;
		box-sizing: border-box;
		/* border: 3px solid ${color.purple}; */
		/* border-radius: 0 14px 14px 0px; */
		border-left: none;
		padding-top: 2rem;
		margin-bottom: 2rem;
		/* background: #111111; */

		.total {
			font-size: 2rem;
			margin-bottom: 3rem;
		}

		span {
			font-size: 1rem;
		}

		.labelBox {
			display: flex;
			margin-bottom: 3rem;
			flex-wrap: wrap;

			.labelRow {
				display: flex;
				align-items: center;
				margin-right: 0.9rem;
				margin-bottom: 0.9rem;
			}

			.level {
				${levelBtn}

				width: fit-content;
				height: fit-content;
				padding: 0.5rem;
				margin-right: 0.3rem;
			}
		}
	}

	li {
		width: 100%;

		list-style: none;
		padding: 1rem;
		box-sizing: border-box;
		cursor: pointer;
		transition: all 0.3s ease-in 0s;

		.header {
			display: flex;
			justify-content: space-between;

			font-size: 0.8rem;
		}

		.level {
			${levelBtn}
		}
	}
`;

const MainItem = styled.div`
	${overflowY}

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	padding: 10rem 4rem 0rem 4rem;
	box-sizing: border-box;
	flex: 4;
	height: 100%;
	box-shadow: 1rem 1rem 1rem #141414;
	background: #141414;
`;

const ProjectName = styled.div`
	display: flex;
	height: 6rem;
	/* margin-left: 6rem; */

	img {
		width: 6rem;
	}

	.content {
		display: flex;
		/* flex-direction: column; */

		justify-content: space-between;
		align-items: flex-start;
		margin-left: 3rem;
		width: 100%;

		input {
			display: flex;
			outline: none;
			background: none;
			border: none;
			font-size: 2rem;
		}

		.severity {
			display: flex;
			flex-direction: column;
			span {
				margin-bottom: 1rem;
			}
		}

		span {
			font-size: 1.5rem;
		}

		.subContent {
			display: flex;
			margin-top: 1rem;

			input {
				font-size: 1.2rem;
				margin-right: 2rem;
			}
		}

		.levelRow {
			display: flex;
			background: #101010;
			border: 1px solid ${color.white};
			border-radius: 0.4rem;
			color: ${color.white};
			width: 10rem;
			height: 2rem;

			.level {
				${levelBtn}

				width: 5rem;
			}
		}
	}
`;

const Description = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	width: 100%;
	margin-top: 7rem;
	/* margin-left: 6rem; */
	/* margin-bottom: 1	rem; */

	.descItem {
		display: flex;
		align-items: center;
		width: 50%;
		margin-bottom: 1.5rem;

		.descTitle {
			font-weight: bold;
			font-size: 1.3rem;
			margin-right: 1.5rem;
			width: 14rem;
		}

		.level {
			${levelBtn}
		}
	}
`;

const DescriptBox = styled.div`
	width: 100%;
	margin-bottom: 3rem;

	h2 {
		font-size: 1.5rem;
		line-height: 1rem;
	}

	textarea {
		${overflowY}
		padding: 1rem 2rem;
		box-sizing: border-box;
		font-size: 1rem;
		background: #141414;
		width: 100%;
		border-radius: 0.4rem;
		outline: none;
		border: none;
		color: ${color.white};
		padding: 1rem 2rem;
		box-sizing: border-box;
		height: 15rem;
		border: 1px solid ${color.white};
		white-space: wrap;

		&::placeholder {
			font-size: 1rem;
			line-height: 2rem;
		}

		li {
			margin-bottom: 1rem;

			&:last-child {
				margin-bottom: 0;
			}
		}
	}
`;

export default HunterDashboard;
